/**
 * **Berpindah layar dari dalam layar lain** — tanpa menyeret router.
 *
 * ### ⛔ Kenapa bukan react-router
 * Konsol ini satu halaman dengan menu samping; layar aktifnya cuma `useState` di `Shell`. Menambah
 * router demi SATU kebutuhan (tautan pintas dari daftar periksa kesiapan) berarti menambah
 * dependensi, URL yang harus dijaga, dan riwayat peramban yang harus dipikirkan — untuk sesuatu
 * yang selesai dengan satu pemberi tahu.
 *
 * ⚠️ Kalau kelak konsol butuh URL yang bisa dibagikan (mis. tautan ke outlet tertentu dari email),
 * jawabannya memang router — dan berkas ini yang diganti, bukan ditambal.
 *
 * ⛔ Nilai `key`-nya WAJIB sama dengan `NAV[].items[].key`. Kunci yang tak ada di menu membuat
 * `Shell` berpindah ke layar yang tak pernah dirender: layar kosong tanpa galat.
 */
type Pendengar = (screenKey: string) => void;

let pendengar: Pendengar | undefined;

/**
 * ⭐⭐⭐ **Outlet yang sedang dibicarakan, dibawa ikut berpindah layar.**
 *
 * ⛔ Tanpa ini, tautan pintas mengantar ke layar yang **tampak kosong**: Routing & Lantai
 * menampilkan "pilih outlet" sampai outletnya dipilih, jadi orang yang baru saja mengklik
 * "perbaiki `print_station` di outlet PB-PKB" mendarat di halaman yang seolah tak punya apa-apa —
 * lalu menyimpulkan fiturnya belum ada. (Dilaporkan Imron, 2026-08-06.)
 *
 * ⚠️ Sekali pakai (`take…`): konteks yang menetap akan memaksa outlet itu terpilih lagi saat orang
 * membuka layarnya sendiri lain kali, dan setelan yang berubah sendiri lebih membingungkan daripada
 * setelan yang kosong.
 */
let konteksOutlet: string | undefined;

/** Mengambil DAN membuang konteks outlet. Dipanggil layar tujuan saat dipasang. */
export function takeOutletContext(): string | undefined {
  const v = konteksOutlet;
  konteksOutlet = undefined;
  return v;
}

/** Dipanggil `Shell` sekali saat dipasang. */
export function onNavigate(fn: Pendengar | undefined): void {
  pendengar = fn;
}

/**
 * Pindah ke layar lain.
 *
 * ⚠️ Diam bila tak ada yang mendengarkan (mis. dalam uji unit) — tautan yang melempar galat karena
 * `Shell` belum dipasang akan mematikan layar yang sebenarnya baik-baik saja.
 */
export function navigateTo(screenKey: string, outletId?: string): void {
  konteksOutlet = outletId;
  pendengar?.(screenKey);
}
